var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 2v2.998M16 2v2.998m4.59 3.836H3.09m5.228 3.161h1.796v6.747m2.512-6.747h1.12c.931 0 1.686.755 1.686 1.685v0c0 .918-.735 1.668-1.653 1.686l-.143.002m-1.01 3.374h1.12c.931 0 1.686-.755 1.686-1.686v0c0-.924-.743-1.676-1.667-1.686l-.129-.002m0 0h-.191M16 3.5c3.33.18 5 1.45 5 6.147v6.177C21 19.941 20 22 15 22H9c-5 0-6-2.059-6-6.177V9.646C3 4.95 4.67 3.69 8 3.5h8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.21d951a56071e6bafe04c9303df53f4d.svg";
export { ForwardRef as ReactComponent };